import ServiceLayout from "../components/ServiceLayout";

export default function MobileApp(){
  return(
    <ServiceLayout
      title="Mobile App Development"
      subtitle="Powerful Android and iOS apps built for performance."
      gradient="linear-gradient(135deg,#36d1dc,#5b86e5)"
      features={[
        "Android Apps",
        "iOS Apps",
        "React Native",
        "Flutter",
        "Push Notifications",
        "App Store Deployment"
      ]}
    />
  );
}
